import { SDKTypes2, SDKTypes3 } from '@/helpers/sdk'

import pinia from '@/stores/pinia'
import useRootStore from '@/stores/root.store'

import PbError from '@/classes/PbError.class'

function parseError(err, meta) {
  if (err instanceof PbError) {
    // If this is an already parsed PbError
    return err
  }

  const { errorPage = false } = meta

  const status = err?.status || null

  if ((err instanceof SDKTypes2.Result || err instanceof SDKTypes3.Result) && err.error) {
    // If this is a result from the SDK
    return new PbError({
      title: err.error.text,
      message: err.error.message,
      errors: err.errors,
      page: errorPage,
      status,
      cause: err,
      meta,
    })
  }

  // If this is any other error
  return new PbError({
    title: err?.title || 'Error while handling request',
    message: err?.message,
    errors: err?.errors,
    page: typeof err?.page !== 'undefined' ? err.page : errorPage,
    status,
    cause: err?.cause || err,
    meta,
  })
}

export async function startHandler({
  // payload,
  // status,
  // data,
  result,
  // error,
  // meta,
} = {}) {
  const rootStore = useRootStore(pinia)
  // Start the global loading
  rootStore.startLoading()
  return result
}

export async function errorHandler({
  // payload,
  // status,
  // data,
  result,
  error,
  meta,
} = {}) {
  const rootStore = useRootStore(pinia)

  const err = parseError(error, meta)
  rootStore.addError(err)

  return result
}

export async function finishHandler({
  // payload,
  // status,
  // data,
  result,
  // error,
  // meta,
} = {}) {
  const rootStore = useRootStore(pinia)
  // Stop the global loading
  rootStore.stopLoading()
  return result
}
